import React, { useCallback } from 'react'
import {
  Grid, Card, Image, Button
} from 'semantic-ui-react'
import { getImageByTemplateId } from '../../utils/functions'
import TemplateButtons from './TemplateButtons'

const TemplateCard = ({ data, onHandleDelete, product }) => {
  const getImageSrc = useCallback((id) => getImageByTemplateId(id), [data])
  return (
    (data && data?.length > 0)
      ? (
        <Grid>
          {
            data?.map(
              (template, i) => {
                const src = getImageSrc(template.id)
                return (
                  <Grid.Column key={i} width={4}>
                    <Card
                      fluid
                    >
                      <div className="btnContainer" style={{ height: '250px', width: '100%' }}>
                        <span style={{
                          position: 'absolute',
                          top: '0px',
                          right: '0px',
                          zIndex: '3',
                          padding: '5px'
                        }}>
                          <Button
                            floated="right"
                            circular icon='close'
                            onClick={(e) => onHandleDelete(e, template.id)}
                          />
                        </span>
                        <Image
                          src={src}
                          style={{
                            height: '100%',
                            width: '100%',
                            objectFit: 'cover',
                            objectPosition: '0 0'
                          }}
                          bordered
                        />
                        <TemplateButtons
                          id={template.id}
                          product={product}
                        />
                      </div>
                      <Card.Content>
                        <Card.Header style={{ paddingBottom: '10px' }}>{template.name || 'Untitled'}</Card.Header>
                      </Card.Content>
                    </Card>
                  </Grid.Column>
                )
              }
            )
          }
        </Grid>
      )
      : ('No results found')
  )
}

export default TemplateCard
